// extracted by mini-css-extract-plugin
module.exports = {"FooterLogo":"FooterLogo_FooterLogo__dcwSX","text":"FooterLogo_text__XXTCG","logo":"FooterLogo_logo__ue2Kk"};